import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Paper,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChooseOption from "./ChooseOption";

export const QEPillars = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const handleOpenDrawer = () => setDrawerOpen(true);
  const handleCloseDrawer = () => setDrawerOpen(false);

  const handleBack = () => {
    // navigate("/dashboard/qe-strategy/archetype-predicted", {
    //   state: {
    //     uploadedCSV:
    //       location.state?.uploadedCSV || location.state?.finalCSV || "",
    //     heatmap: location.state?.heatmap64,
    //     pie_chart: location.state?.pie_chart64,
    //     primary_radar_chart: location.state?.primary_radar_chart64,
    //     secondary_radar_chart: location.state?.secondary_radar_chart64,
    //     tertiary_radar_chart: location.state?.tertiary_radar_chart64,
    //     predicted_archetypes: location.state?.selectedArchetypes,
    //     discoveryLayeroutput: location.state?.backendData,
    //   },
    // });

    navigate(-1);
  };

  const [backendData, setBackendData] = useState(null);
  const [topQEpillars, setTopQEpillars] = useState(null);
  const [selectedArchetypes, setSelectedArchetypes] = useState([]);
  const [topQEpillarsChart, setTopQEpillarsChart] = useState("");
  const [pillarsPieChart, setPillarsPieChart] = useState("");
  const [individualRadarCharts, setIndividualRadarCharts] = useState("");
  const [finalCSV, setFinalCSV] = useState("");
  const [initialCombinedCSV, setInitialCombinedCSV] = useState("");
  const [updatedConfidences, setUpdatedConfidences] = useState(null);

  useEffect(() => {
    // Get data from navigation state (similar to how DataCentricAndCapabilityAlignedQA gets data)
    const {
      backendData,
      topQEpillars,
      pillarTestSuggestions,
      selectedArchetypes,
      topQEpillarsChart,
      individualRadarCharts,
      pillarsPieChart,
      finalCSV,
      initialCombinedCSV,
      updatedConfidences,
    } = location.state || {};

    if (backendData && topQEpillars) {
      setBackendData(backendData);
      setTopQEpillars(topQEpillars);
      setSelectedArchetypes(selectedArchetypes || []);
      setTopQEpillarsChart(topQEpillarsChart);
      setPillarsPieChart(pillarsPieChart);
      setIndividualRadarCharts(individualRadarCharts);
      setFinalCSV(finalCSV);
      setInitialCombinedCSV(initialCombinedCSV);
      setUpdatedConfidences(updatedConfidences);
    }
  }, [location.state]);

  if (!topQEpillars) {
    return (
      <Box sx={{ p: 3 }}>
       
          {location.state
            ? "Loading..."
            : "No advisory layer data available. Please go sthrough the archetype selection process."}
    
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ p: 3, marginBottom: 2 }}>
        <Typography variant="h4" gutterBottom sx={{ fontSize: "24px", fontWeight: 600, fontStyle: "SemiBold", letterSpacing: "0.15px" }}>
          QE Pillars
        </Typography>

        {/* Selected Archetypes Section */}
        {selectedArchetypes.length > 0 && (
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Selected Archetypes
              </Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {selectedArchetypes.map((archetype, index) => (
                  <Chip
                    key={index}
                    label={archetype}
                    color="secondary"
                    variant="filled"
                  />
                ))}
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Top QE Pillars Section */}

        {/* <Typography
            gutterBottom
            sx={{ fontWeight: 600, fontStyle: "SemiBold", fontSize: "20px" }}
          >
            QMentisAI Identified top QE Pillars
          </Typography> */}
        {/* <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {topQEpillarsChart && (
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <img
                      src={topQEpillarsChart}
                      alt="Top QE Pillars Chart"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Box>
                </CardContent>
              </Card>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {pillarsPieChart && (
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <img
                      src={pillarsPieChart}
                      alt="Top QE Pillars Chart"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Box>
                </CardContent>
              </Card>
            )}
          </Box>

          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {individualRadarCharts &&
              Object.entries(individualRadarCharts).map(([key, chartData]) => (
                <Card key={key} sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ mb: 2, textTransform: "capitalize" }}
                    >
                      {key.replace(/_/g, " ")}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <img
                        src={chartData}
                        alt={`${key.replace(/_/g, " ")} Chart`}
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </Box>
                  </CardContent>
                </Card>
              ))}
          </Box> */}

        {/* Top Charts Row: Pie chart first, then Top QE Pillars bar chart */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {pillarsPieChart && (
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, fontSize: "20px", fontStyle: "SemiBold" }}>
                    QMentisAI Identified QE Pillars
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1 }}>
                    <img
                      src={pillarsPieChart}
                      alt="Pillars Pie Chart"
                      style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}

          {topQEpillarsChart && (
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, fontSize: "20px", fontStyle: "SemiBold" }}>
                    QMentisAI Identified Top {topQEpillars.length} QE Pillars
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1 }}>
                    <img
                      src={topQEpillarsChart}
                      alt="Top QE Pillars Chart"
                      style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        {/* <Typography>Top{topQEpillars.length} QE Pillars</Typography> */}

        <Typography
          sx={{
            fontFamily: "Manrope",
            fontWeight: 600, // Note: 'SemiBold' is usually mapped to 600
            fontStyle: "normal", // 'SemiBold' is not a valid font-style
            fontSize: "24px",
            lineHeight: "100%",
            letterSpacing: "0.15px",
            verticalAlign: "middle",
            color: "#0094FB",
            marginBottom: 2
          }}
        >
          Top {topQEpillars.length} QE Pillars
        </Typography>

        {/* Individual Radar Charts - 2 per row */}
        <Grid container spacing={2}>
          {individualRadarCharts &&
            Object.entries(individualRadarCharts).map(([key, chartData]) => (
              <Grid item xs={12} md={6} key={key}>
                <Card>
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        textTransform: "capitalize",
                        textAlign: "center",
                        fontSize: "20px",
                        fontStyle: "SemiBold",
                        fontWeight: 600,
                      }}
                    >
                      {key.replace(/_/g, " ")}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%", maxHeight: "400px", objectFit: "contain" // Auto height to maintain aspect ratio
                      }}
                    >
                      <img
                        src={chartData}
                        alt={`${key.replace(/_/g, " ")} Chart`}
                        style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>


        {/* Backend Data - Pillar Test Suggestions */}
        {/* <Typography variant="h6" gutterBottom>
        Pillar Test Suggestions
      </Typography>

      <Grid container spacing={2}>
        {Object.entries(backendData).map(([pillarName, pillarData]) => (
          <Grid item xs={12} md={6} lg={4} key={pillarName}>
            <Paper elevation={2} sx={{ p: 2, height: "100%" }}>
              <Typography variant="h6" gutterBottom color="primary">
                {pillarName}
              </Typography>

              <Typography variant="body2" gutterBottom>
                <strong>Confidence:</strong> {pillarData.confidence}
              </Typography>

              <Typography variant="body2" gutterBottom>
                <strong>Test Types:</strong>
              </Typography>

              <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mt: 1 }}>
                {pillarData.test_types.map((testType, index) => (
                  <Chip
                    key={index}
                    label={testType}
                    size="small"
                    variant="outlined"
                    color="secondary"
                  />
                ))}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid> */}
      </Box>
      {/* Footer Buttons */}

      <Box
        mt={4}
        display="flex"
        justifyContent="space-between"
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "#f6f3f2",
          padding: 1.2,
          paddingLeft: 3,
          paddingRight: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Button variant="outlined" startIcon={<ArrowBackIcon />} 
        onClick={handleBack}
        sx={{ textTransform: 'none', fontSize: "16px", border: '2px solid #0094FB', borderRadius: '8px', gap: '8px' }}>
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          endIcon={<ArrowForwardIcon />}
          onClick={handleOpenDrawer}
          sx={{ textTransform: 'none', fontSize: "16px",backgroundColor:"#0094FB",  border: '2px solid #0094FB', borderRadius: '8px', gap: '8px' }}
        >
          Proceed
        </Button>
      </Box>

      {/* Drawer */}
      <ChooseOption open={isDrawerOpen} onClose={handleCloseDrawer} />
    </Box>
  );
};
